import { registerOnce } from '@/helpers/Widget'

import SetupDvpWidget from '@/modules/SetupDvpWidget/components/SetupDvpWidget'

registerOnce(SetupDvpWidget, '#setupDvpWidget')
